"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_1 = require("@cian/logger/browser");
var browser_2 = require("@cian/config/browser");
var internal_1 = require("./internal");
var browser_3 = require("@cian/telemetry/browser");
var httpApi;
var httpApiSetupSettings;
var setup = function (settings) {
    httpApiSetupSettings = settings;
};
exports.setup = setup;
var init = function () {
    if (httpApi) {
        return httpApi;
    }
    browser_1.init();
    browser_3.init();
    var config = browser_2.init();
    var circuitBreakerHash = httpApiSetupSettings.circuitBreakerHash, assertStatusCode = httpApiSetupSettings.assertStatusCode;
    var settings = new internal_1.HttpApiSettings({ config: config, assertStatusCode: assertStatusCode, circuitBreakerHash: circuitBreakerHash });
    httpApi = new internal_1.HttpApi({ settings: settings });
    return httpApi;
};
exports.init = init;
var getHttpApi = function () {
    if (!httpApi) {
        throw new Error('HttpApi not initialized yet, call init function first');
    }
    return httpApi;
};
exports.getHttpApi = getHttpApi;
//# sourceMappingURL=interface.js.map